var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',_vm._l((_vm.wetter.wetterStationen),function(wetterStation){return _c('el-row',{key:wetterStation.ID_Wetterstation},[_c('wetter-chart',{attrs:{"wetter-daten":wetterStation.wetterDaten}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }